import { useState, useContext } from 'react';
import { AppContext } from './context'
import UiButton1 from './ui_button1';
import UiSpinner from './ui_spinner';

const UiPopupSidebarDeleteProfile = ({ closeSidebar }) => {

    const {
        toDeleteProfile, setToDeleteProfile,
        neonUser,
        offCanvas,
        setReloadProfileList,
        setToastContent,
        toastInit,
        fetchDataV2
    } = useContext(AppContext)

    const [load, setLoad] = useState(false)

    const deleteMarketplaceProfile = async () => {
        setLoad(true)

        let query1 = neonUser.role == "admin" ?
            "GET_AUTHORIZED_MARKETPLACE_BY_ID_ADMIN" :
            "GET_AUTHORIZED_MARKETPLACE_BY_ID_AGENCY",
            params1 = neonUser.role == "admin" ? [toDeleteProfile] : [toDeleteProfile, neonUser.agency_id]

        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

        if (!resp || resp.length == 0) {
            setLoad(false)
            return
        }

        try {
            let query2 = "UPDATE_CLIENT_PROFILE_ACTIVE_BY_ID", params2 = [resp[0].client_profile_id]
            await fetchDataV2(query2, params2, "/neon-market-v2")
        } catch (err) {
            setLoad(false)
            return
        }

        let query3 = "INSERT_DELETED_DATA", params3 = [neonUser.user_id, JSON.stringify({ authorized_marketplace: resp })]
        await fetchDataV2(query3, params3, "/neon-query-v2")

        let query4 = neonUser.role == "admin" ?
            "DELETE_AUTHORIZED_MARKETPLACE_BY_ID_ADMIN" :
            "DELETE_AUTHORIZED_MARKETPLACE_BY_ID_AGENCY",
            params4 = neonUser.role == "admin" ? [toDeleteProfile] : [toDeleteProfile, neonUser.agency_id]

        await fetchDataV2(query4, params4, "/neon-query-v2")

        setToDeleteProfile("")
        closeSidebar()
        offCanvas.hide()
        setReloadProfileList(true)
        setToastContent("Profile is deleted.")
        toastInit.show()
        setLoad(false)
    }

    return (
        <div className="h-100 d-flex flex-column justify-content-between">
            <p className="poppins">Confirm Delete this Profile?</p>
            {load ?
                <UiSpinner />
                :
                <UiButton1 text="Delete" submit={deleteMarketplaceProfile} />
            }
        </div>
    )
}

export default UiPopupSidebarDeleteProfile